/* eslint-disable import/first */
import React from 'react';
/* eslint-disable import/first */
import { Redux, Slices } from 'spwa-ui-library';
const { useSelector, useDispatch } = Redux;
import { Grid, Typography } from '@material-ui/core';
import { FormattedMessage } from 'react-intl';
import { decimalChecker } from 'spwa-ui-library/esm/utils/helper';
const { selectFirstMenu } = Slices.menuSlice;

const { selectCurrentCountry } = Slices.profileSlice;
const { selectCountryValidations } = Slices.configSlice;

import css from './index.module.scss';
const UnableProcess = ({ orderInfo, enableState, ordStatus }) => {
  // if (ordStatus !== 'PENDING' && !enableState) {
  //   return '';
  // }
  const menu = useSelector(selectFirstMenu);
  const currency = menu && menu.currency;
  const country = useSelector(selectCurrentCountry);
  const countryValidations = useSelector((state) => selectCountryValidations(state, country));

  return (
    <Grid className={css.root}>
      <Grid className={css.headerText}>
        <Typography>
          {ordStatus === 'PENDING' && !enableState && (
            <FormattedMessage
              id="unableProcess_orderPending"
              defaultMessage="You will receive an sms shortly with information on the status of the order"
            />
          )}
          {ordStatus == 'CANCELED' && (
            <FormattedMessage
              id="unable_ordercancelled"
              defaultMessage="We're sorry to inform you that we had to cancel your order."
            />
          )}
          {ordStatus == 'FAILURE' && (
            <FormattedMessage
              id="unable_orderprocess"
              defaultMessage="Unable to process your order"
            />
          )}
        </Typography>
      </Grid>
      <Grid className={css.descText}>
        <Typography>
          <FormattedMessage
            id="try_again"
            values={{
              customerCare: countryValidations?.customerCare,
            }}
            defaultMessage="Please try again after 15 minutes or call us on"
          />
        </Typography>
      </Grid>
      {/* <>
        {ordStatus === 'PENDING' && !enableState && orderInfo?.payment?.name === 'CARD' ? (
          <Grid className={css.refundArea}>
            <Grid className={css.headerText}></Grid>
            <Grid className={css.descText}>
              <Typography>
                <FormattedMessage
                  id={`refundBeforePayment`}
                  values={{
                    amount: decimalChecker(orderInfo?.payment?.amount),
                  }}
                />
              </Typography>
            </Grid>
          </Grid>
        ) : (
          ''
        )}
      </> */}
      {(ordStatus === 'FAILURE' || ordStatus === 'CANCELED') &&
      (orderInfo?.payment?.status === 'CAPTURE' ||
        orderInfo?.payment?.status === 'REFUND' ||
        orderInfo?.payment?.name === 'VISA_CHECKOUT') ? (
        ''
      ) : (
        // <Grid className={css.refundArea}>
        //   <Grid className={css.headerText}>
        //     <Typography>
        //       <FormattedMessage id="refund_initiated" defaultMessage="Refund initiated" />
        //     </Typography>
        //   </Grid>
        //   <Grid className={css.descText}>
        //     <Typography>
        //       <FormattedMessage
        //         id={`refund_initiated_businessdays`}
        //         values={{
        //           amount: decimalChecker(orderInfo?.payment?.amount),
        //           currency: currency,
        //         }}
        //       />
        //     </Typography>
        //   </Grid>
        // </Grid>
        <>
          {/* {ordStatus !== 'PENDING' && orderInfo?.payment?.name === 'CARD' ? (
            <Grid className={css.refundArea}>
              <Grid className={css.headerText}></Grid>
              <Grid className={css.descText}>
                <Typography>
                  <FormattedMessage
                    id={`refundBeforePayment`}
                    values={{
                      amount: decimalChecker(orderInfo?.payment?.amount),
                    }}
                  />
                </Typography>
              </Grid>
            </Grid>
          ) : (
            ''
          )} */}
        </>
      )}
    </Grid>
  );
};

export default UnableProcess;
